import { gql } from "@apollo/client";

export const USER_TOKEN = gql`
  query UserToken($permissions: [String!], $expirationTime: String) {
    userToken(permissions: $permissions, expirationTime: $expirationTime) {
      accessToken
    }
  }
`;
